module.exports = __webpack_public_path__ + "static/media/2.8ad7d8cd.jpg";